(function () {
function $ed458539e9aca6fc$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $dd5d475c18a11b8a$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $cd4faa234a512600$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $24d56453e0849fdb$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $f38300b62951504b$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $24d56453e0849fdb$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $24d56453e0849fdb$export$71511d61b312f219)(o, minLen);
}


function $5f90e0097f717d37$export$71511d61b312f219(arr, i) {
    return (0, $ed458539e9aca6fc$export$71511d61b312f219)(arr) || (0, $dd5d475c18a11b8a$export$71511d61b312f219)(arr, i) || (0, $f38300b62951504b$export$71511d61b312f219)(arr, i) || (0, $cd4faa234a512600$export$71511d61b312f219)();
}


function $79f3c2e8250c0af8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $79f3c2e8250c0af8$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $79f3c2e8250c0af8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $79f3c2e8250c0af8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $8b63bd7c91aaf532$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $988fd894c2f87491$var$extendStatics = function extendStatics1(d, b) {
    $988fd894c2f87491$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $988fd894c2f87491$var$extendStatics(d, b);
};
function $988fd894c2f87491$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $988fd894c2f87491$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $988fd894c2f87491$export$18ce0697a983be9b = function __assign1() {
    $988fd894c2f87491$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $988fd894c2f87491$export$18ce0697a983be9b.apply(this, arguments);
};
function $988fd894c2f87491$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $988fd894c2f87491$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $988fd894c2f87491$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $988fd894c2f87491$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $988fd894c2f87491$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $988fd894c2f87491$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $8b63bd7c91aaf532$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $988fd894c2f87491$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $8b63bd7c91aaf532$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $988fd894c2f87491$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $988fd894c2f87491$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $988fd894c2f87491$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $988fd894c2f87491$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $988fd894c2f87491$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $988fd894c2f87491$export$45d3717a4c69092e(o, m, p);
}
function $988fd894c2f87491$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $988fd894c2f87491$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $988fd894c2f87491$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($988fd894c2f87491$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $988fd894c2f87491$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $988fd894c2f87491$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $988fd894c2f87491$export$10c90e4f7922046c(v) {
    return this instanceof $988fd894c2f87491$export$10c90e4f7922046c ? (this.v = v, this) : new $988fd894c2f87491$export$10c90e4f7922046c(v);
}
function $988fd894c2f87491$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $988fd894c2f87491$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $988fd894c2f87491$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $988fd894c2f87491$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $988fd894c2f87491$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $988fd894c2f87491$export$19a8beecd37a4c45 === "function" ? $988fd894c2f87491$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $988fd894c2f87491$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $988fd894c2f87491$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $988fd894c2f87491$var$ownKeys = function ownKeys1(o) {
    $988fd894c2f87491$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $988fd894c2f87491$var$ownKeys(o);
};
function $988fd894c2f87491$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $988fd894c2f87491$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $988fd894c2f87491$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $988fd894c2f87491$var$__setModuleDefault(result, mod);
    return result;
}
function $988fd894c2f87491$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $988fd894c2f87491$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $988fd894c2f87491$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $988fd894c2f87491$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $988fd894c2f87491$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $988fd894c2f87491$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $988fd894c2f87491$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $988fd894c2f87491$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $988fd894c2f87491$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $988fd894c2f87491$export$2e2bcd8739ae039 = {
    __extends: $988fd894c2f87491$export$a8ba968b8961cb8a,
    __assign: $988fd894c2f87491$export$18ce0697a983be9b,
    __rest: $988fd894c2f87491$export$3c9a16f847548506,
    __decorate: $988fd894c2f87491$export$29e00dfd3077644b,
    __param: $988fd894c2f87491$export$d5ad3fd78186038f,
    __esDecorate: $988fd894c2f87491$export$3a84e1ae4e97e9b0,
    __runInitializers: $988fd894c2f87491$export$d831c04e792af3d,
    __propKey: $988fd894c2f87491$export$6a2a36740a146cb8,
    __setFunctionName: $988fd894c2f87491$export$d1a06452d3489bc7,
    __metadata: $988fd894c2f87491$export$f1db080c865becb9,
    __awaiter: $988fd894c2f87491$export$1050f835b63b671e,
    __generator: $988fd894c2f87491$export$67ebef60e6f28a6,
    __createBinding: $988fd894c2f87491$export$45d3717a4c69092e,
    __exportStar: $988fd894c2f87491$export$f33643c0debef087,
    __values: $988fd894c2f87491$export$19a8beecd37a4c45,
    __read: $988fd894c2f87491$export$8d051b38c9118094,
    __spread: $988fd894c2f87491$export$afc72e2116322959,
    __spreadArrays: $988fd894c2f87491$export$6388937ca91ccae8,
    __spreadArray: $988fd894c2f87491$export$1216008129fb82ed,
    __await: $988fd894c2f87491$export$10c90e4f7922046c,
    __asyncGenerator: $988fd894c2f87491$export$e427f37a30a4de9b,
    __asyncDelegator: $988fd894c2f87491$export$bbd80228419bb833,
    __asyncValues: $988fd894c2f87491$export$e3b29a3d6162315f,
    __makeTemplateObject: $988fd894c2f87491$export$4fb47efe1390b86f,
    __importStar: $988fd894c2f87491$export$c21735bcef00d192,
    __importDefault: $988fd894c2f87491$export$da59b14a69baef04,
    __classPrivateFieldGet: $988fd894c2f87491$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $988fd894c2f87491$export$d40a35129aaff81f,
    __classPrivateFieldIn: $988fd894c2f87491$export$81fdc39f203e4e04,
    __addDisposableResource: $988fd894c2f87491$export$88ac25d8e944e405,
    __disposeResources: $988fd894c2f87491$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $988fd894c2f87491$export$889dfb5d17574b0b
};


var $73fe26212c9cb1c4$export$ca000e230c0caa3e = {
    data: []
};
var $73fe26212c9cb1c4$export$8ea9b17c5f70aae9 = function() {
    var _ref = (0, $79f3c2e8250c0af8$export$71511d61b312f219)(function(data) {
        return (0, $988fd894c2f87491$export$67ebef60e6f28a6)(this, function(_state) {
            $73fe26212c9cb1c4$export$ca000e230c0caa3e.data.push(data);
            return [
                2
            ];
        });
    /*
  try {
    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbyBK7L5IYndhOF7i5AONVK1XU_keI4XfAScPfD2Q7N4VHbZs73qmEcot20iso4SmSMx/exec",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) throw new Error("Network response was not ok");
    const result = await response.json();
    console.log(result);
  } catch (error) {
    console.error("Fetch error:", error);
  }
  */ });
    return function addResponse(data) {
        return _ref.apply(this, arguments);
    };
}();


function $f295fb496dff8c4b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $50e5fc84fb41e892$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $50e5fc84fb41e892$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $50e5fc84fb41e892$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $50e5fc84fb41e892$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c239c5472cf2662b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $6febe11530efda0b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $24d56453e0849fdb$export$71511d61b312f219)(arr);
}


function $ba10d72e4e8c1ba8$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $24d92ef4107f926c$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $8324aa946d4fe06a$export$71511d61b312f219(arr) {
    return (0, $6febe11530efda0b$export$71511d61b312f219)(arr) || (0, $ba10d72e4e8c1ba8$export$71511d61b312f219)(arr) || (0, $f38300b62951504b$export$71511d61b312f219)(arr) || (0, $24d92ef4107f926c$export$71511d61b312f219)();
}


var $8246d6b49e6cd2f7$var$ContactView = /*#__PURE__*/ function() {
    "use strict";
    function ContactView() {
        (0, $f295fb496dff8c4b$export$71511d61b312f219)(this, ContactView);
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "parentEl", document.querySelector("#contactForm"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "modal", document.querySelector(".modal"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "overlay", document.querySelector(".modal__overlay"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "btnCloseModal", document.querySelector(".button--close"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "btnsOpenModal", document.querySelectorAll(".btn--show-modal"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "openModal", function() {
            this.modal.classList.remove("hidden");
            this.overlay.classList.remove("hidden");
        });
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "closeModal", function() {
            this.modal.classList.add("hidden");
            this.overlay.classList.add("hidden");
        });
        this.addHandlerOpenWindow();
        this.addHandlerCloseWindow();
    }
    (0, $50e5fc84fb41e892$export$71511d61b312f219)(ContactView, [
        {
            key: "addHandlerOpenWindow",
            value: function addHandlerOpenWindow() {
                var _this = this;
                this.btnsOpenModal.forEach(function(btn) {
                    btn.addEventListener("click", _this.openModal.bind(_this));
                });
            }
        },
        {
            key: "addHandlerCloseWindow",
            value: function addHandlerCloseWindow() {
                this.btnCloseModal.addEventListener("click", this.closeModal.bind(this));
                this.overlay.addEventListener("click", this.closeModal.bind(this));
            // document.addEventListener("keydown", (e) => {
            //   if (e.key === "Enter") this.closeModal();
            // });
            }
        },
        {
            key: "addHandlerSubmitForm",
            value: function addHandlerSubmitForm(handler) {
                var _this = this;
                this.parentEl.addEventListener("submit", function(e) {
                    e.preventDefault();
                    var dataArr = (0, $8324aa946d4fe06a$export$71511d61b312f219)(new FormData(_this.parentEl));
                    var data = Object.fromEntries(dataArr);
                    _this.closeModal();
                    handler(data);
                });
            }
        }
    ]);
    return ContactView;
}();
var $8246d6b49e6cd2f7$export$2e2bcd8739ae039 = new $8246d6b49e6cd2f7$var$ContactView();





var $9e1b03c99970968c$var$NavToggleView = /*#__PURE__*/ function() {
    "use strict";
    function NavToggleView() {
        (0, $f295fb496dff8c4b$export$71511d61b312f219)(this, NavToggleView);
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "parentEl", document.querySelector(".nav__links"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "navToggle", document.querySelector(".nav__toggle"));
        this.checkViewportWidth(); // Check width on load
        window.addEventListener("resize", this.checkViewportWidth.bind(this)); // Listen for resize
        this.addhandlerToggle();
    }
    (0, $50e5fc84fb41e892$export$71511d61b312f219)(NavToggleView, [
        {
            key: "checkViewportWidth",
            value: function checkViewportWidth() {
                if (window.innerWidth <= 985) this.parentEl.classList.add("hidden");
                else this.parentEl.classList.remove("hidden");
            }
        },
        {
            key: "toggleNav",
            value: function toggleNav() {
                this.parentEl.classList.toggle("hidden");
                console.log("toggle");
            }
        },
        {
            key: "hideNav",
            value: function hideNav() {
                if (window.innerWidth <= 985) this.parentEl.classList.add("hidden");
            }
        },
        {
            key: "addhandlerToggle",
            value: function addhandlerToggle() {
                var _this = this;
                [
                    "click"
                ].forEach(function(ev, i) {
                    _this.navToggle.addEventListener(ev, _this.toggleNav.bind(_this));
                    _this.parentEl.addEventListener(ev, function(e) {
                        var link = e.target.closest(".nav__link");
                        if (!link) return;
                        console.log("hide");
                        _this.hideNav();
                    });
                });
            }
        }
    ]);
    return NavToggleView;
}();
var $9e1b03c99970968c$export$2e2bcd8739ae039 = new $9e1b03c99970968c$var$NavToggleView();





var $2ec57b15a7d2001f$var$SliderView = /*#__PURE__*/ function() {
    "use strict";
    function SliderView() {
        (0, $f295fb496dff8c4b$export$71511d61b312f219)(this, SliderView);
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "parentEl", document.querySelector(".slider"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "sliderHeading", document.querySelector(".slider__heading"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "forkifyHeading", document.querySelector(".forkify__heading"));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "headings", Array.from(document.querySelectorAll(".slider__heading")));
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "newHeadings", [
            "Pokemon Deck Builder",
            "Forkify Recipe App",
            "To Do List"
        ]);
        (0, $c239c5472cf2662b$export$71511d61b312f219)(this, "longHeadings", [
            "Pokemon Deck Building App",
            "Forkify: Recipe Search Application",
            "To Do List"
        ]);
        window.addEventListener("resize", this.checkViewportWidth.bind(this));
    }
    (0, $50e5fc84fb41e892$export$71511d61b312f219)(SliderView, [
        {
            key: "checkViewportWidth",
            value: function checkViewportWidth() {
                var _this = this;
                if (window.innerWidth <= 450) this.headings.forEach(function(h, i) {
                    h.textContent = _this.newHeadings[i];
                });
                else this.headings.forEach(function(h, i) {
                    h.textContent = _this.longHeadings[i];
                });
            }
        }
    ]);
    return SliderView;
}();
var $2ec57b15a7d2001f$export$2e2bcd8739ae039 = new $2ec57b15a7d2001f$var$SliderView();


// class EyebrowsView {
//   eyebrows = document.querySelectorAll(".eyebrow");
//   constructor() {
//     this.addHandlerChangeEyebrow();
//     window.addEventListener("resize", this.checkViewportWidth.bind(this));
//     window.addEventListener("load", this.checkViewportWidth.bind(this));
//   }
//   checkViewportWidth() {
//     if (window.innerWidth <= 450) {
//       this.eyebrows.forEach((eyebrow) => {
//         eyebrow.style.fontSize = "1.6rem";
//         eyebrow.style.fontWeight = "600";
//         const heading = eyebrow.textContent.toUpperCase();
//         eyebrow.textContent = heading;
//       });
//     } else {
//       this.eyebrows.forEach((eyebrow) => {
//         eyebrow.style.fontSize = "2.4rem";
//         eyebrow.style.fontWeight = "600";
//         const heading = eyebrow.textContent.toUpperCase();
//         eyebrow.textContent = heading;
//       });
//     }
//   }
//   addHandlerChangeEyebrow() {}
// }
// export default new EyebrowsView();


"use strict";
// Elements
var $b66c5b751205a629$var$header = document.querySelector(".header");
var $b66c5b751205a629$var$nav = document.querySelector(".nav");
var $b66c5b751205a629$var$overview = document.querySelector("#overview");
var $b66c5b751205a629$var$navLinks = document.querySelector(".nav__links");
var $b66c5b751205a629$var$navItem = document.querySelectorAll(".nav__link");
var $b66c5b751205a629$var$allSections = document.querySelectorAll(".section");
var $b66c5b751205a629$var$navToggle = document.querySelector(".nav__toggle");
// Event handlers
document.querySelector("body").addEventListener("click", function(e) {});
//////////////////////////////////////////
// Reveal Sections
var $b66c5b751205a629$var$revealSection = function revealSection(entries, observer) {
    var _entries = (0, $5f90e0097f717d37$export$71511d61b312f219)(entries, 1), entry = _entries[0];
    if (!entry.isIntersecting) return;
    entry.target.classList.remove("section--hidden");
};
var $b66c5b751205a629$var$sectionObserver = new IntersectionObserver($b66c5b751205a629$var$revealSection, {
    root: null,
    threshold: 0.15
});
$b66c5b751205a629$var$allSections.forEach(function(section) {
    // section.classList.add("section--hidden");
    $b66c5b751205a629$var$sectionObserver.observe(section);
});
//////////////////////////////////////////
// Sticky nav
var $b66c5b751205a629$var$navHeight = $b66c5b751205a629$var$nav.getBoundingClientRect().height;
var $b66c5b751205a629$var$stickyNav = function stickyNav(entries, observer) {
    var _entries = (0, $5f90e0097f717d37$export$71511d61b312f219)(entries, 1), entry = _entries[0];
    console.log(entry);
    if (!entry.isIntersecting) $b66c5b751205a629$var$nav.classList.add("sticky");
    else $b66c5b751205a629$var$nav.classList.remove("sticky");
};
var $b66c5b751205a629$var$headerObserver = new IntersectionObserver($b66c5b751205a629$var$stickyNav, {
    root: null,
    threshold: 0.15,
    rootMargin: "-".concat($b66c5b751205a629$var$navHeight, "px")
});
$b66c5b751205a629$var$headerObserver.observe($b66c5b751205a629$var$header);
//////////////////////////////////////////
// Nav Button Hover effect
var $b66c5b751205a629$var$hoverHandler = function hoverHandler(e) {
    var _this = this;
    if (e.target.classList.contains("nav__link")) {
        var link = e.target;
        var siblings = link.closest(".nav").querySelectorAll(".nav__link");
        var logo = link.closest(".nav").querySelector("img");
        // Lighten siblings and logo
        siblings.forEach(function(el) {
            if (e.target !== el) el.style.opacity = _this;
        });
    // logo.style.opacity = this;
    }
};
$b66c5b751205a629$var$navLinks.addEventListener("mouseover", $b66c5b751205a629$var$hoverHandler.bind(0.5));
$b66c5b751205a629$var$navLinks.addEventListener("mouseout", $b66c5b751205a629$var$hoverHandler.bind(1));
//////////////////////////////////////////
// Underline effect
var $b66c5b751205a629$var$underline = document.querySelector(".underline");
window.addEventListener("load", function(e) {
    if (!$b66c5b751205a629$var$underline) return;
    $b66c5b751205a629$var$underline.classList.add("underline--active");
});
//////////////////////////////////////////
// Jump to sections
$b66c5b751205a629$var$nav.querySelectorAll(".nav__item").forEach(function(item) {
    return item.addEventListener("click", function(e) {
        e.preventDefault();
        var id = e.target.getAttribute("href");
        if (!id) return;
        var targetSection = document.querySelector(id);
        var navHeight = $b66c5b751205a629$var$nav.getBoundingClientRect().height;
        console.log(targetSection, id);
        var yOffsetInitial = window.pageYOffset === 0 ? -navHeight + 10 : 0;
        var yOffset = -navHeight;
        var yPosition = targetSection.getBoundingClientRect().top + (window.pageYOffset + yOffsetInitial) + yOffset;
        console.log(window.pageYOffset);
        window.scrollTo({
            top: yPosition,
            behavior: "smooth"
        });
    // document.querySelector(id).scrollIntoView({ behavior: "smooth" });
    });
});
//////////////////////////////////////////
// Slider
var $b66c5b751205a629$var$slider = document.querySelector(".slider");
var $b66c5b751205a629$var$slides = document.querySelectorAll(".slide");
var $b66c5b751205a629$var$btnRight = document.querySelector(".slider__btn--right");
var $b66c5b751205a629$var$btnLeft = document.querySelector(".slider__btn--left");
var $b66c5b751205a629$var$dotsContainer = document.querySelector(".dots");
// Default working view
// slider.style.overflow = "visible";
// slider.style.scale = "0.5";
// slider.style.transform = "translateX(-700px)";
var $b66c5b751205a629$var$sliderCode = function sliderCode() {
    var curSlide = 0;
    var maxSlide = $b66c5b751205a629$var$slides.length;
    var createDots = function createDots(slide) {
        // select container and populate with dot html
        $b66c5b751205a629$var$slides.forEach(function(_, i) {
            $b66c5b751205a629$var$dotsContainer.insertAdjacentHTML("beforeend", '<button class="dots__dot dots__dot--active" data-slide="'.concat(i, '"></button>'));
        });
    };
    var activateDots = function activateDots(slide) {
        // Reset dots to non active
        document.querySelectorAll(".dots__dot").forEach(function(dot) {
            dot.classList.remove("dots__dot--active");
        });
        // assign active dot
        document.querySelector('.dots__dot[data-slide="'.concat(slide, '"]')).classList.add("dots__dot--active");
    };
    var goToSlide = function goToSlide(slide) {
        $b66c5b751205a629$var$slides.forEach(function(s, i) {
            s.style.transform = "translateX(".concat((i - slide) * 100, "%)");
        });
    };
    var nextSlide = function nextSlide() {
        if (curSlide === maxSlide - 1) curSlide = 0;
        else curSlide++;
        goToSlide(curSlide);
        activateDots(curSlide);
    };
    var prevSlide = function prevSlide() {
        if (curSlide === 0) curSlide = maxSlide - 1;
        else curSlide--;
        goToSlide(curSlide);
        activateDots(curSlide);
    };
    $b66c5b751205a629$var$btnRight.addEventListener("click", nextSlide);
    $b66c5b751205a629$var$btnLeft.addEventListener("click", prevSlide);
    $b66c5b751205a629$var$dotsContainer.addEventListener("click", function(e) {
        if (e.target.classList.contains("dots__dot")) {
            curSlide = +e.target.dataset.slide;
            goToSlide(curSlide);
            activateDots(curSlide);
        }
    });
    var initSlider = function initSlider(slide) {
        createDots(curSlide);
        goToSlide(0);
        activateDots(curSlide);
    };
    initSlider(curSlide);
};
$b66c5b751205a629$var$sliderCode();
/////////////////////////////////////////
// Tabbed Section
var $b66c5b751205a629$var$tabs = document.querySelector(".tabs");
var $b66c5b751205a629$var$tabsBtnsContainer = document.querySelector(".tabs__btns");
var $b66c5b751205a629$var$tabsBtns = document.querySelectorAll(".tabs__btn");
var $b66c5b751205a629$var$tabsContent = document.querySelectorAll(".tabs__content");
// Tab btn active
// tabsBtnsContainer.addEventListener("click", function (e) {
//   e.preventDefault();
//   if (!e.target.classList.contains("tabs__btn")) return;
//   tabsBtns.forEach(function (btn) {
//     btn.classList.remove("tabs__btn--active");
//     e.target.classList.add("tabs__btn--active");
//   });
//   // Switch active tab content
//   tabsContent.forEach(function (tab) {
//     tab.classList.remove("tabs__content--active");
//   });
//   document
//     .querySelector(`.tabs__content--${e.target.dataset.tab}`)
//     .classList.add("tabs__content--active");
// });
//////////////////////////////////////
// Controller
var $b66c5b751205a629$var$controlSubmitForm = function controlSubmitForm(data) {
    $73fe26212c9cb1c4$export$8ea9b17c5f70aae9(data);
    console.log($73fe26212c9cb1c4$export$ca000e230c0caa3e);
};
var $b66c5b751205a629$var$init = function init() {
    (0, $8246d6b49e6cd2f7$export$2e2bcd8739ae039).addHandlerSubmitForm($b66c5b751205a629$var$controlSubmitForm);
};
$b66c5b751205a629$var$init();

})();
//# sourceMappingURL=index.08ae06e0.js.map
